export default __webpack_public_path__ + "static/media/menu.34184556.svg";